import { isDefined } from '@sgme/fp';
import { useData } from 'components/common-form/hooks/useData';
import { useFieldMetadata } from 'components/common-form/hooks/useFieldMetadata';
import { useFieldTranslationKey } from 'components/common-form/hooks/useFieldTranslationKey';
import { BlockOrientationFormGroup } from 'components/shared/FormGroup';
import { QuoteRepriceLink } from 'components/shared/QuoteRepriceLink';
import { useIsInternalUser } from 'hooks/useIsInternalUser';
import type { ExternalQuoteIdFieldData, ExternalQuoteIdFieldMetadata } from 'models/forms/fields';
import { FC } from 'react';

import type { ProductNodeBuilderProps } from '../ProductNodeBuilder.model';

export const ExternalQuoteIdField: FC<ProductNodeBuilderProps> = props => {
  const {
    node: { id },
    workspaceType,
    tabIndex,
  } = props;
  const [value] = useData<ExternalQuoteIdFieldData>(id);
  const translationKey = useFieldTranslationKey(id);
  const isInternal = useIsInternalUser();

  const { targetWorkspaceType } = useFieldMetadata<ExternalQuoteIdFieldMetadata>(id)!;

  return (
    <BlockOrientationFormGroup inputId={id} label={`form.${translationKey}` as any} workspaceType={workspaceType}>
      {isDefined(value) && (
        <QuoteRepriceLink
          className="justify-content-between h-100 px-2"
          externalQuoteId={value}
          targetWorkspace={targetWorkspaceType ?? undefined}
          disabled={targetWorkspaceType === null}
          canShare={isInternal}
          tabIndex={tabIndex}
        />
      )}
    </BlockOrientationFormGroup>
  );
};

ExternalQuoteIdField.displayName = 'ExternalQuoteIdField';
